import { createFileRoute } from '@tanstack/react-router'
import CreateMockTest from '@/features/create-practice-test'

export const Route = createFileRoute(
  '/_authenticated/create-practice-test/$moduleId'
)({
  component: CreateMockTestWrapper,
})

function CreateMockTestWrapper() {
  const { moduleId } = Route.useParams() as {
    moduleId: string
    classId: string
  }
  return <CreateMockTest key={`${moduleId}`} moduleId={moduleId} />
}

export default Route
